import { render, staticRenderFns } from "./owner-type.vue?vue&type=template&id=1afbec4a&"
import script from "./owner-type.vue?vue&type=script&lang=js&"
export * from "./owner-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports